import { useState } from "react";

import {
  FormRow,
  SelectSheet,
  SelectSheetOption,
} from "../../../../components/MobileForm";
import {
  Card,
  CardLabel,
  HelperText,
  RowsCard,
} from "../../../../components/MobileForm/styles";
import { ToneSegments } from "../../../../components/FormPanel";
import {
  SETTLEMENT_HELPER,
  SETTLEMENT_LABEL,
  SETTLEMENT_LOCKED_NOTE,
  SETTLEMENT_SEGMENTS,
  settlementSummaryOf,
} from "./settlement";
import { MobileCashSettlementFieldProps } from "./types";

export const MobileCashSettlementField = ({
  settlement,
  isSubmitting,
  error,
  onPickAccount,
}: MobileCashSettlementFieldProps) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const isLinked = settlement.value === "LINKED_ACCOUNT";

  if (!settlement.isShown) {
    return null;
  }

  if (!settlement.isEditable) {
    return (
      <Card>
        <CardLabel as="span">{SETTLEMENT_LABEL}</CardLabel>
        <strong>{settlementSummaryOf(settlement)}</strong>
        <HelperText>{SETTLEMENT_LOCKED_NOTE}</HelperText>
      </Card>
    );
  }

  return (
    <>
      <CardLabel as="span">{SETTLEMENT_LABEL}</CardLabel>
      <ToneSegments
        groupLabel={SETTLEMENT_LABEL}
        options={SETTLEMENT_SEGMENTS}
        selectedValue={settlement.value}
        disabled={isSubmitting}
        onChange={(segment) => settlement.onChange(segment.value)}
      />
      <HelperText>{SETTLEMENT_HELPER}</HelperText>

      {isLinked && (
        <RowsCard>
          <FormRow
            label="Paying account"
            value={settlement.account?.label}
            placeholder="Select account"
            error={error}
            onClick={() => setIsSheetOpen(true)}
          />
        </RowsCard>
      )}

      <SelectSheet
        isOpen={isSheetOpen}
        title="Select paying account"
        options={settlement.accountOptions}
        selectedValue={settlement.account?.value}
        onSelect={(option) => {
          onPickAccount(option);
          setIsSheetOpen(false);
        }}
        onClose={() => setIsSheetOpen(false)}
      />
    </>
  );
};
